var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 5,
    fill: "#EB5757"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_347_380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.13757 19.9248C8.84337 19.9419 8.55403 19.8441 8.33056 19.652C7.88985 19.2087 7.88985 18.4927 8.33056 18.0494L17.9807 8.3992C18.4391 7.97028 19.1583 7.99412 19.5873 8.4525C19.9751 8.86701 19.9977 9.50412 19.6402 9.94506L9.9332 19.652C9.71262 19.8414 9.42792 19.939 9.13757 19.9248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7764 19.9248C18.4782 19.9236 18.1924 19.8052 17.9807 19.5952L8.33053 9.94502C7.92224 9.46823 7.97775 8.75068 8.45454 8.34234C8.88009 7.97792 9.5077 7.97792 9.93321 8.34234L19.6402 17.9925C20.0985 18.4215 20.1222 19.1409 19.6931 19.5991C19.6761 19.6173 19.6584 19.635 19.6402 19.652C19.4025 19.8587 19.0897 19.9575 18.7764 19.9248Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_347_380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.f42b282d0be56d6eff87b84dbf7374de.svg";
export { ForwardRef as ReactComponent };